// Logic for the Contact us page, kept free of React and the router so it can
// be unit tested. The limits mirror POST /api/contact in posso-help-api
// (cmd/api/contact_handlers.go); the API re-validates everything.

// Support WhatsApp line (+1 561 803 5111), digits only, country code first.
export const SUPPORT_WA = process.env.REACT_APP_SUPPORT_WA || '15618035111';

export const MAX_NAME = 100;
export const MAX_EMAIL = 254;
export const MAX_PHONE = 40;
export const MIN_MESSAGE = 10;
export const MAX_MESSAGE = 5000;

const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
// eslint-disable-next-line no-control-regex
const CONTROL_RE = /[\u0000-\u001f\u007f-\u009f]/;

// Length in characters (code points), as the API counts them.
const length = (s) => [...s].length;

export const whatsappLink = (text, number = SUPPORT_WA) =>
  `https://wa.me/${number}?text=${encodeURIComponent(text)}`;

// Returns { field: i18nKey } for every invalid field; empty when valid. The
// keys are the same codes the API answers with, so both paths share copy.
export const validateContact = ({ name, email, phone, message }) => {
  const errors = {};
  const n = (name || '').trim();
  const e = (email || '').trim();
  const p = (phone || '').trim();
  const m = (message || '').trim();

  if (!n || length(n) > MAX_NAME || CONTROL_RE.test(n)) errors.name = 'contact_name_invalid';
  if (!EMAIL_RE.test(e) || e.length > MAX_EMAIL || CONTROL_RE.test(e)) errors.email = 'contact_email_invalid';
  if (length(p) > MAX_PHONE) errors.phone = 'contact_phone_invalid';
  if (length(m) < MIN_MESSAGE) errors.message = 'contact_message_too_short';
  else if (length(m) > MAX_MESSAGE) errors.message = 'contact_message_too_long';
  return errors;
};

// The logged-in user, as stored by Login/VerifyEmail. Never throws.
export const readStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem('zapmanejo_user') || 'null') || {};
  } catch (e) {
    return {};
  }
};
